export default __webpack_public_path__ + "static/media/Vector-2.fa17e1a8.svg";